module.exports = __webpack_public_path__ + "img/logossgAttend.4bebd916.png";